import { matchPath } from "react-router-dom";
import InvalidElement from "../../domain/Folder/InvalidElementInterface";
import LocalStorageGateway from "../../gateway/Form/LocalStorageGateway";
import envVariable from "./envVariable";
import { FormReferential, FormReferentials, UserInfoInterface } from "./storageTypes";


export default class storage {
  private static getFolderIdFromUrl(): string | null {
    if (typeof window === 'undefined') return null;
    const match = matchPath<{ dossierId?: string }>(window.location.pathname, {
      path: '/dossier/:dossierId',
    });
    return match?.params?.dossierId ?? null;
  }

  private static getKey(baseKey: string, folderId?: string | null): string {
    const effectiveFolderId = folderId ?? storage.getFolderIdFromUrl();
    return effectiveFolderId ? `${effectiveFolderId}_${baseKey}` : baseKey;
  }
  static setFolderId(folder_id: string): boolean  {
    storage.clearReferential()
    localStorage.setItem(envVariable('REACT_APP_FOLDER_ID_STORAGE'), folder_id)
    return true
  }

  static getFolderId(): string|null {
    return localStorage.getItem(envVariable('REACT_APP_FOLDER_ID_STORAGE'))
  }

  static setFormId(form_id: string, folderId?: string | null): boolean  {
    storage.clearReferential()
    localStorage.setItem(storage.getKey('form_id', folderId), form_id)
    return true
  }

  static getFormId(folderId?: string | null): string|null {
    return localStorage.getItem(storage.getKey('form_id', folderId))
  }

  static getClientFormId(): string {
    return localStorage.getItem(envVariable('REACT_APP_CLIENT_FORM_ID_STORAGE')) ?? envVariable('REACT_APP_FORM_ID')
  }

  static getBackOfficeFormId(): string {
    return localStorage.getItem(envVariable('REACT_APP_BACKOFFICE_FORM_ID_STORAGE')) ?? envVariable('REACT_APP_BACKOFFICE_FORM_ID')
  }

  static getBackOfficeConventionFormId(): string {
    return localStorage.getItem(envVariable('REACT_APP_BACKOFFICE_CONVENTION_FORM_ID_STORAGE')) ?? envVariable('REACT_APP_BACKOFFICE_CONVENTION_FORM_ID')
  }

  static getDossierState(folderId?: string | null): string {
    return localStorage.getItem(storage.getKey('dossier_state', folderId)) ?? ''
  }

  static setDossierState(state: string, folderId?: string | null): boolean {
    localStorage.setItem(storage.getKey('dossier_state', folderId), state)
    return true
  }

  static getToReSign(folderId?: string | null): boolean {
    const value = localStorage.getItem(storage.getKey('to_re_sign', folderId))
    return value === 'true'
  }

  static getUnableToCorrect(folderId?: string | null): boolean {
    const value = localStorage.getItem(storage.getKey('able_to_correct', folderId))
    return value === 'true'
  }

  static hasToReSignValue(folderId?: string | null): boolean {
    const value = localStorage.getItem(storage.getKey('to_re_sign', folderId))
    return value !== null && value !== 'null'
  }

  static setReferential(formId: string, referential: FormReferential): boolean {
    const presentRef = localStorage.getItem('referential');
    const newRef = presentRef ? JSON.parse(presentRef) : {};

    newRef[formId] = referential;
    localStorage.setItem('referential', JSON.stringify(newRef));
    return true;
  }

  static getReferential(formId: string): FormReferential | null {
    const formReferentials = this.getReferentials()
    return formReferentials ? formReferentials[formId] ?? null : null
  }

  static getReferentials(): FormReferentials | null {
    const jsonReferentials = localStorage.getItem('referential')
    return jsonReferentials ? JSON.parse(jsonReferentials) : null
  }

  static clearReferential(): void {
    localStorage.removeItem('referential')
  }

  static getClientId(folderId?: string | null): number|null {
    const clientId = Number(localStorage.getItem(storage.getKey('client_id', folderId)))
    return (isNaN(clientId)) ? null : clientId
  }

  static setClientId(clientId: number, folderId?: string | null): boolean {
    localStorage.setItem(storage.getKey('client_id', folderId), String(clientId))
    return true
  }

  static getAuthorizedClients(folderId?: string | null): number[]|null {
    const authorizedClients = localStorage.getItem(storage.getKey('authorized_clients', folderId))
    if (authorizedClients != null) {
      return JSON.parse(authorizedClients)
    }

    return null
  }

  static setAuthorizedClients(clientsId: number[], folderId?: string | null): boolean {
    localStorage.setItem(storage.getKey('authorized_clients', folderId), JSON.stringify(clientsId))
    return true
  }

  static getReceipts(elementId: string, folderId?: string | null): boolean {
    const receiptsString = localStorage.getItem(storage.getKey('receipts', folderId))

    if (receiptsString != null) {
      const receipts = JSON.parse(receiptsString)

      const result = receipts.filter(receipt => receipt.elementId === elementId)
      return result.length > 0
    }

    return false
  }

  static getUserInformation(): UserInfoInterface|null
  {
    const userProfile = localStorage.getItem('profile')
    return userProfile ? JSON.parse(userProfile) : null
  }

  static clearCredentials(): void {
    localStorage.removeItem(envVariable('REACT_APP_LOCAL_STORAGE_TOKEN_NAME'));
    localStorage.removeItem('profile')
    localStorage.removeItem('referential');
    LocalStorageGateway.clearAllFolderData();
  }

  static getRole(): string {
    return localStorage.getItem('role') ?? ''
  }

  static getInvalidElements(folderId?: string | null): InvalidElement[] {
    const invalidElements = localStorage.getItem(storage.getKey('invalidElements', folderId))

    if (!invalidElements || invalidElements === 'null') {
      return []
    }

    try {
      const parsedInvalidElements = JSON.parse(invalidElements);

      if (Array.isArray(parsedInvalidElements)) {
        return parsedInvalidElements.map(item => ({
          id: item.id,
          comment: item.reason ?? item.comment,
          value: item.value,
          elementId: item.element_id ?? item.elementId,
          blockId: item.block_id ?? item.blockId,
          receiptId: item.receipt_id ?? item.receiptId,
          pageId: item.page_id ?? item.pageId,
        })) as InvalidElement[]
      }

      return []

    } catch (e) {
      console.error("Erreur lors de la lecture des éléments invalides du localStorage:", e)
      return []
    }
  }

  static getAdvisorId(folderId?: string | null): string|null {
    const value = localStorage.getItem((storage.getKey('advisor_id', folderId)))
    return value !== null && value !== 'null' ? value : null
  }
}
